{
  "branding": {
    "frontdesk-attribution": "Con tecnología de FrontDesk+",
    "practice-logo": "Logotipo de {{name}}"
  },
  "validation": {
    "required": "Este campo es obligatorio",
    "invalid-url": "Por favor ingrese una URL válida",
    "pin-too-short": "El PIN debe tener al menos 4 caracteres",
    "pin-default-rejected": "El PIN estándar 0000 no está permitido. Asigne su propio PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Atrás",
    "next": "Siguiente",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "done": "Hecho",
    "retry": "Reintentar",
    "clear": "Limpiar",
    "close": "Cerrar",
    "verifying": "Verificando...",
    "select": "Seleccionar",
    "minutes": "minutos",
    "clock": "",
    "gender": {
      "M": "Masculino",
      "W": "Femenino",
      "D": "Diverso",
      "U": "Desconocido"
    },
    "insurance": {
      "GKV": "Legal",
      "PKV": "Privado",
      "SELFPAY": "Pago propio"
    },
    "scroll-up": "Desplazar hacia arriba",
    "scroll-down": "Desplazar hacia abajo"
  },
  "settings": {
    "device-reset": {
      "title": "Restablecer dispositivo",
      "description": "Eliminar la conexión con la consulta, los ajustes y el PIN de este dispositivo.",
      "confirmation": "Será necesario configurar este dispositivo de nuevo. La configuración de SOL y los datos de pacientes en inSuite no cambiarán.",
      "cancel": "Cancelar",
      "confirm": "Restablecer ahora"
    },
    "title": "Configuración",
    "save": "Guardar",
    "save-success": "Configuración guardada",
    "save-error": "Error al guardar la configuración",
    "load-error": "Error al cargar la configuración",
    "pin": {
      "title": "PIN Requerido",
      "description": "Por favor, introduce tu PIN para acceder a la configuración.",
      "error": "PIN incorrecto. Por favor, inténtalo de nuevo.",
      "backspace": "Borrar el último dígito"
    },
    "connection": {
      "title": "Conexión",
      "description": "Configuración de conexión para el servidor Doc-Cirrus Bridge",
      "bridge-url": "URL del Bridge",
      "device-name": "Nombre del dispositivo",
      "device-name-placeholder": "por ej. Recepción, Sala 1, Quiosco",
      "device-name-hint": "Nombre para identificación en el panel de Bridge",
      "kim-address": "Dirección KIM (opcional)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Probar",
      "success": "Conexión exitosa",
      "error": "Conexión fallida",
      "api-unreachable": "API DocCirrus inalcanzable",
      "status-title": "Estado de conexión",
      "status": {
        "api": "API conectada",
        "ti": "Infraestructura telemática",
        "card-reader": "Lector de tarjetas disponible",
        "medical-card": "Tarjeta del consultorio médico (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Token Sol (de inSuite)",
      "sol-token-hint": "Cópielo de la administración de Bridge en inSuite. Necesario para la conexión.",
      "sol-token-show": "Mostrar token",
      "sol-token-hide": "Ocultar token",
      "bridge-unreachable": "No se puede acceder a Bridge. Compruebe la dirección y el puerto.",
      "diagnostic-id": "ID de diagnóstico: {{id}}",
      "scan-qr": "Escanear código QR",
      "scan-title": "Escanear código QR de Bridge",
      "scan-manual": "Introducir manualmente"
    },
    "terminal": {
      "title": "Lector de tarjetas",
      "description": "Selección del lector de tarjetas para la infraestructura telemática",
      "select": "Seleccionar Terminal",
      "select-placeholder": "Elegir terminal...",
      "loading": "Cargando terminales...",
      "none-available": "No hay terminales disponibles",
      "none-found": "No se encontraron terminales",
      "found": "{{count}} terminal(es) encontrado(s)",
      "connect-hint": "Conéctate primero al servidor bridge para cargar los terminales.",
      "found-count": "Lectores de tarjetas encontrados: {{count}}",
      "refresh": "Volver a cargar lectores de tarjetas"
    },
    "practice": {
      "title": "Consultorio médico",
      "description": "Información sobre su consultorio médico",
      "name": "Nombre del consultorio médico",
      "name-placeholder": "ej. Dr. Juan Pérez",
      "welcome-message": "Mensaje de bienvenida",
      "welcome-placeholder": "p. ej., Bienvenido a nuestro consultorio médico",
      "scheduler-available": "Habilitar programador",
      "scheduler-available-description": "Permitir a los pacientes reservar citas a través de la terminal de autoservicio",
      "prescription-available": "Habilitar servicio de recetas",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Déjelo vacío para saludar a los pacientes en su idioma. Su propio texto se muestra sin cambios en todos los idiomas."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Guardado para todos los dispositivos el {{value}}",
      "never-saved-default": "Configuración predeterminada, aún sin cambios."
    },
    "anamnesis": {
      "title": "Historial Médico Digital",
      "description": "Muestra un enlace y QR code a su proveedor de historial médico después del check-in.",
      "enabled": "Mostrar enlace al historial médico después del check-in",
      "enabled-description": "Muestra un enlace y QR code a su proveedor de historial médico después de un registro completo, por ejemplo Nelly.",
      "url": "Enlace del proveedor de historial médico",
      "url-hint": "El enlace es estático e idéntico para todos los pacientes.",
      "preview-label": "Vista previa de la pantalla de finalización",
      "preview-note": "El enlace es estático e idéntico para todos los pacientes.",
      "url-first": "Introduzca primero un enlace válido para activarlo."
    },
    "appearance": {
      "title": "Apariencia",
      "description": "Personalizar la interfaz de usuario",
      "language": "Idioma",
      "default-kiosk-language": "Idioma predeterminado del paciente",
      "default-kiosk-language-hint": "Idioma en el que comienzan las nuevas sesiones de quiosco para los pacientes.",
      "voice-over-volume": "Volumen de voz en off",
      "voice-over-hint": "Controla el volumen del asistente de voz para accesibilidad.",
      "language-first": "Mostrar la selección de idioma al iniciar la sesión"
    },
    "security": {
      "title": "Seguridad",
      "description": "PIN para acceder a la configuración",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Administración del quiosco",
    "nav": {
      "general": "General",
      "flows": "Funciones",
      "anamnese": "Anamnesis digital",
      "device": "Dispositivo y conexión"
    },
    "flows": {
      "title": "Funciones en el terminal"
    },
    "language": {
      "title": "Idioma y voz",
      "description": "Idioma y lectura en voz alta para los pacientes en este dispositivo."
    }
  },
  "self-service": {
    "title": "Autoservicio",
    "step-progress": "Paso {{current}} / {{total}}",
    "flows": {
      "checkin": "Check-in",
      "scheduler": "Reservar cita",
      "prescription": "Recetas",
      "locations": "Mapa de ubicación",
      "emergency": "Emergencia"
    },
    "audio-guide": {
      "on": "Sonido activado",
      "off": "Sonido desactivado",
      "replay": "Repetir indicaciones",
      "replay-unavailable": "No hay indicaciones de voz para repetir"
    },
    "language-selector": {
      "title": "Seleccionar idioma",
      "description": "Por favor seleccione su idioma preferido"
    },
    "settings": "Configuración",
    "start": {
      "welcome": "Bienvenido",
      "subtitle": "Por favor, selecciona una opción",
      "check-in-label": "Camino principal",
      "check-in-cta": "Check-in",
      "check-in-description": "¿Ya tienes una cita? Regístrate aquí.",
      "check-in-hint": "Ten tu tarjeta lista",
      "scheduler-label": "Nuevo",
      "scheduler-cta": "Reservar cita",
      "scheduler-description": "Programa una nueva cita.",
      "location-plan": "Mapa de ubicación",
      "location-plan-description": "Encuentra el camino a la sala de tratamiento.",
      "prescription-label": "Prescripción",
      "prescription-cta": "Recetas y pedidos",
      "prescription-description": "Ver recetas o pedir resurtidos.",
      "emergency-cta": "Alerta de emergencia local",
      "emergency-description": "Solo suena en este dispositivo; no pide ayuda.",
      "tap-to-start": "Toca para comenzar"
    },
    "offline": {
      "banner-title": "Check-in no disponible temporalmente",
      "banner-message": "Por favor hable con el personal de recepción para obtener ayuda.",
      "emergency-available": "La alerta local sigue disponible. No pide ayuda.",
      "flow-disabled": "No disponible temporalmente"
    },
    "readability": {
      "toggle-label": "Modo de lectura",
      "on": "Modo de lectura",
      "off": "Modo de lectura"
    },
    "reset-overlay": {
      "timeout-title": "Sesión finalizada",
      "timeout-subtitle": "Tu tiempo ha expirado. Tus datos están seguros.",
      "offline-title": "Conexión perdida",
      "offline-subtitle": "La conexión fue interrumpida. Por favor hable con el personal de recepción.",
      "interruption-title": "Sesión finalizada",
      "interruption-subtitle": "Su sesión ha finalizado de forma segura.",
      "completion-title": "¡Gracias!",
      "completion-subtitle": "Su solicitud se ha completado con éxito.",
      "reassurance": "Sus datos personales no se almacenan en este dispositivo.",
      "auto-dismiss": "Volviendo al inicio en {{seconds}} segundos...",
      "dismiss": "ir a empezar"
    },
    "timed-terminal": {
      "countdown": "Retorno automático en {{seconds}} segundos",
      "countdown-outcome": "Este terminal volverá automáticamente a la pantalla de inicio.",
      "more-time": "Más tiempo",
      "extended": "Tiempo extendido"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Estas preguntas no están disponibles en su idioma. Elija uno de los idiomas ofrecidos o diríjase a recepción.",
        "alternatives": "Citas alternativas",
        "loading": "Cargando preguntas…",
        "reception-fallback": "Diríjase a recepción.",
        "error-title": "No se pudieron cargar las preguntas",
        "language-unavailable-lead": "Estas preguntas no están disponibles en su idioma.",
        "language-unavailable-title": "Elija uno de estos idiomas",
        "language-unavailable-body": "O pida ayuda en recepción."
      },
      "start": {
        "title": "Reservar cita",
        "subtitle": "Reserva tu cita preferida en unos pocos pasos",
        "welcome": "Bienvenido a la reserva de citas",
        "description": "Te guiaremos a través del proceso de reserva",
        "cta": "Reservar cita ahora"
      },
      "patient-id": {
        "title": "Identificación",
        "subtitle": "Por favor, identifícate",
        "mode-card": "Con tarjeta",
        "mode-search": "Buscar",
        "mode-create": "Crear nuevo",
        "insert-card": "Por favor, inserta tu tarjeta de seguro",
        "reading-card": "Leyendo tarjeta...",
        "simulate-card": "Simular tarjeta",
        "multiple-matches": "Se encontraron varios pacientes. Usando datos de la tarjeta.",
        "search-placeholder": "Nombre o número de seguro...",
        "searching": "Buscando...",
        "no-results": "No se encontraron resultados",
        "first-name": "Nombre",
        "last-name": "Apellido",
        "dob": "Fecha de nacimiento",
        "insurance": "Seguro",
        "continue": "Continuar",
        "creating": "Creando paciente...",
        "patient-created": "¡Paciente creado exitosamente!",
        "create-error": "No se pudo crear el paciente."
      },
      "appointment-type": {
        "title": "Seleccionar tipo de cita",
        "subtitle": "Por favor, selecciona el motivo de tu visita",
        "loading": "Cargando tipos de cita...",
        "no-types": "No hay tipos de cita disponibles",
        "error": "No se pudieron cargar los tipos de cita. Por favor, inténtalo de nuevo.",
        "no-bookable": "Estos tipos de cita no se pueden reservar actualmente en el quiosco. Acuda a recepción o programe la cita por teléfono.",
        "disabled-default": "Programe esta cita directamente en recepción o por teléfono.",
        "disabled-footer": "Solo recepción/teléfono",
        "lead": "¿Qué tipo de cita desea reservar?",
        "duration": "aprox. {{minutes}} minutos",
        "empty-title": "Ahora mismo no se pueden reservar citas aquí",
        "none-bookable-title": "Estas citas no se pueden reservar aquí",
        "none-bookable-body": "Pregunte en recepción o llámenos."
      },
      "types": {
        "general": "Consulta general",
        "general-desc": "Para quejas y preguntas generales",
        "checkup": "Chequeo preventivo",
        "checkup-desc": "Controles de salud regulares",
        "vaccination": "Vacunación",
        "vaccination-desc": "Programar una vacunación",
        "followup": "Seguimiento",
        "followup-desc": "Cita de control",
        "prescription": "Receta",
        "prescription-desc": "Recogida de receta"
      },
      "slot-selection": {
        "title": "Seleccionar cita",
        "subtitle": "Por favor, selecciona una cita disponible",
        "loading": "Cargando citas disponibles...",
        "no-slots": "No hay citas disponibles",
        "no-appointment-type": "No se ha seleccionado ningún tipo de cita",
        "error": "No se pudieron cargar las citas disponibles. Por favor, inténtalo de nuevo.",
        "quick-select": "Próximas citas disponibles:",
        "select-date": "O selecciona una fecha:",
        "times-for": "{{date}}",
        "available": "Disponible",
        "unavailable": "Sin citas",
        "slots": "citas",
        "select-time-hint": "Toca una hora para reservar tu cita",
        "week-short": "Sem",
        "weekday-mon": "Lun",
        "weekday-tue": "Mar",
        "weekday-wed": "Mié",
        "weekday-thu": "Jue",
        "weekday-fri": "Vie",
        "weekday-sat": "Sáb",
        "weekday-sun": "Dom",
        "period-morning": "Mañana",
        "period-midday": "Mediodía",
        "period-afternoon": "Tarde",
        "period-evening": "Noche",
        "period-morning-short": "Mañ.",
        "period-midday-short": "Med.",
        "period-afternoon-short": "Tar.",
        "period-evening-short": "Noc.",
        "period-dots-legend": "Disponibilidad horaria",
        "filter-hint": "Filtrar por horas preferidas:",
        "or-choose-below": "o elige a continuación",
        "no-slots-period": "Sin espacios",
        "show-all": "Mostrar todo",
        "free": "gratis",
        "your-selection": "Tu selección",
        "oclock": "en punto",
        "choose-slot": "Elige ranura",
        "choose-day": "Elegir día",
        "choose-day-first": "Elija primero un día",
        "times-heading": "Horas libres el {{date}}",
        "time-value": "{{time}}",
        "empty-title": "No hay citas libres en {{month}}",
        "empty-body": "Mire el mes siguiente o pregunte en recepción, le ayudaremos con gusto.",
        "next-month": "Mes siguiente",
        "previous-month": "Mes anterior"
      },
      "confirmation": {
        "patient-responses": "Sus respuestas",
        "review-loading": "Comprobando el resumen…",
        "review-unavailable": "Resumen no disponible. Inténtelo de nuevo o pregunte en recepción.",
        "check-booking": "Comprobar la reserva",
        "title": "Confirmar cita",
        "subtitle": "Por favor, revisa tu reserva",
        "patient": "Paciente",
        "datetime": "Fecha y hora",
        "booking": "Reservando...",
        "confirm": "Reservar cita",
        "heading": "¿Esto se ve bien?",
        "lead": "Por favor confirme su cita.",
        "appointment": "Cita",
        "insured-via": "Asegurado a través de",
        "description-label": "Notas para la consulta (opcional)",
        "description-hint": "Indíquenos si debemos tener algo en cuenta al reservar la cita o durante el registro.",
        "description-placeholder": "p. ej., movilidad reducida, acompañante, indicaciones importantes",
        "description-too-long": "Reduzca la nota a 500 caracteres como máximo.",
        "summary": "Resumen",
        "change": "Cambiar",
        "book-binding": "Reservar cita",
        "cancel": "Cancelar",
        "type-label": "Tipo de cita",
        "datetime-value": "{{date}} a las {{time}}",
        "name-label": "Nombre",
        "insurance-label": "Seguro",
        "insurance-GKV": "Seguro médico público",
        "insurance-PKV": "Seguro médico privado",
        "insurance-SELFPAY": "Pago propio",
        "change-time": "Cambiar cita",
        "description-free-text": "Otras indicaciones (opcional)",
        "note-wheelchair": "Uso silla de ruedas",
        "note-companion": "Vengo acompañado/a",
        "note-interpreter": "Necesito un intérprete"
      },
      "done": {
        "title": "¡Cita reservada!",
        "label": "Reservado",
        "subtitle": "Tu cita ha sido reservada con éxito.",
        "date": "Fecha",
        "time": "Hora",
        "booking-id": "Número de reserva",
        "qr-hint": "Añadir a tu calendario",
        "qr-description": "Escanea este código QR con la cámara de tu smartphone para añadir la cita a tu aplicación de calendario",
        "auto-redirect": "Serás redirigido a la página de inicio en breve...",
        "auto-redirect-countdown": "Volviendo al inicio en {{seconds}} segundos...",
        "back-to-start": "Volver al inicio",
        "print-button": "Imprimir justificante de cita",
        "print-preparing": "Preparando la vista de impresión…",
        "print-error": "No se pudo abrir el justificante de cita. Inténtelo de nuevo o pida ayuda en recepción.",
        "print-returned": "Se ha cerrado la vista de impresión del sistema. Puede solicitar otra copia si la necesita.",
        "print-title": "Su cita",
        "print-location": "Lugar",
        "print-map-hint": "Abrir el lugar en el teléfono",
        "print-error-v2": "No se pudo abrir el justificante de la cita. Inténtelo de nuevo o pregunte en recepción."
      },
      "error": {
        "assistance-info": "No pudimos confirmar su reserva. Es posible que su cita ya esté reservada. Pregunte en recepción.",
        "pending-title": "Reserva no confirmada",
        "pending-info": "No pudimos confirmar su reserva. Es posible que su cita ya esté reservada. Compruébelo de nuevo o pregunte en recepción.",
        "title": "Error al reservar",
        "subtitle": "No se pudo reservar la cita.",
        "info": "Inténtelo de nuevo o pregunte en recepción."
      },
      "phase": {
        "identify": "Identificarse",
        "choose": "Elegir hora",
        "confirm": "Confirmar"
      }
    },
    "prescription": {
      "start": {
        "title": "Recetas y pedidos",
        "subtitle": "Inserte su tarjeta de seguro para ver recetas o solicitar resurtidos.",
        "button": "Insertar tarjeta"
      },
      "card-check": {
        "loading": "Cargando lector de tarjetas...",
        "no-terminal": "No hay lector de tarjetas configurado",
        "no-terminal-hint": "Comuníquese con el personal para obtener ayuda.",
        "insert-card": "Por favor inserte su tarjeta",
        "insert-card-hint": "Inserte su tarjeta de seguro en el lector de tarjetas.",
        "card-detected": "Tarjeta detectada",
        "reading": "Tarjeta de lectura...",
        "reading-hint": "Espere un momento.",
        "error": "Error al leer la tarjeta",
        "retry": "Inténtalo de nuevo",
        "manual-lookup": "Continuar sin tarjeta",
        "load-error": "No se pudo cargar el lector de tarjetas",
        "read-error": "La tarjeta no se pudo leer."
      },
      "patient-selection": {
        "title": "Seleccionar Paciente",
        "subtitle": "Se encontraron múltiples pacientes. Por favor seleccione su nombre.",
        "try-again": "Inténtalo de nuevo",
        "try-again-hint": "Insertar tarjeta nuevamente"
      },
      "list": {
        "title": "Tus recetas",
        "for-patient": "Recetas para {{name}}",
        "loading": "Cargando recetas...",
        "error-title": "Error de carga",
        "fetch-error": "No se pudieron cargar las recetas",
        "back-home": "Volver al inicio",
        "done": "hecho"
      },
      "detail": {
        "prescription-info": "Información de prescripción",
        "date": "Fecha",
        "prescriber": "Prescriptor",
        "comment": "Nota",
        "medications": "Medicamentos",
        "form": "Formulario",
        "pack-size": "Tamaño del paquete",
        "manufacturer": "Fabricante",
        "loading": "Cargando receta...",
        "fetch-error": "No se pudieron cargar los detalles de la receta",
        "back-to-list": "Volver a la lista",
        "print": "Imprimir"
      },
      "types": {
        "public": "Prescripción pública",
        "private": "Prescripción privada",
        "long-term": "Prescripción a largo plazo",
        "btm": "Receta de narcóticos",
        "g": "Receta verde",
        "t": "T-Prescripción"
      },
      "no-patient": {
        "title": "Paciente no encontrado",
        "subtitle": "Lamentablemente no se encontró ningún paciente para esta tarjeta. Comuníquese con el personal para obtener ayuda.",
        "try-again": "Inténtalo de nuevo",
        "back-home": "Volver al inicio",
        "title-v2": "No se encontraron datos coincidentes",
        "subtitle-v2": "No pudimos encontrarle. Inténtelo de nuevo o pregunte en recepción."
      },
      "done": {
        "title": "gracias",
        "subtitle": "Puedes tomar asiento ahora. Si tiene preguntas, comuníquese con el personal.",
        "no-prescriptions-title": "No hay recetas en el archivo",
        "no-prescriptions-subtitle": "No pudimos encontrar ninguna receta activa para usted. Si esperaba uno, póngase en contacto con el personal de recepción.",
        "error-title": "Se produjo un error",
        "error-subtitle": "Comuníquese con el personal para obtener más ayuda.",
        "auto-redirect": "Redirección automática en {{seconds}} segundos",
        "finish": "Volver al inicio"
      },
      "hub": {
        "title": "Tus recetas",
        "for-patient": "Recetas para {{name}}",
        "loading": "Cargando recetas...",
        "error-title": "Error de carga",
        "fetch-error": "No se pudieron cargar recetas",
        "back-home": "Volver al inicio",
        "done": "hecho",
        "order-button": "Ordenar receta",
        "existing-prescriptions": "Tus recetas actuales",
        "no-prescriptions": "No se encontraron recetas activas."
      },
      "patient-lookup": {
        "title": "encontrar paciente",
        "subtitle": "Ingrese su nombre y fecha de nacimiento.",
        "last-name": "Apellido",
        "first-name": "Nombre",
        "date-of-birth": "Fecha de nacimiento",
        "lastname": "Apellido",
        "lastname-placeholder": "tu apellido",
        "firstname": "Nombre",
        "firstname-placeholder": "tu nombre",
        "dob": "Fecha de nacimiento",
        "search": "Buscar",
        "searching": "Buscando...",
        "search-error": "Error de búsqueda: {{message}}",
        "no-match": "No se encontró ningún paciente. Por favor verifique su información.",
        "error": "Error de búsqueda. Por favor inténtalo de nuevo.",
        "found": "Paciente encontrado",
        "confirm": "Confirmar",
        "ambiguous": "Múltiples coincidencias",
        "ambiguous-hint-firstname": "Introduzca también su nombre para refinar la búsqueda.",
        "ambiguous-hint-additional": "Por favor verifique su información o comuníquese con el personal.",
        "not-found": "Paciente no encontrado",
        "not-found-hint": "No se pudo encontrar ningún paciente con estos detalles.",
        "not-found-action": "Inténtalo de nuevo"
      },
      "manual-identification": {
        "unverified": "Su identidad no se confirmó con la tarjeta sanitaria. La consulta verificará sus datos y la solicitud antes de tramitarla."
      },
      "medication-selection": {
        "title": "Solicitar una receta",
        "subtitle": "El consultorio médico revisa su solicitud. Una vez aprobada, el eRx estará listo en su aplicación e-prescription.",
        "back": "Atrás",
        "submit": "Continuar revisando",
        "reason-title": "¿Por qué necesitas la receta?",
        "reason-hint": "Ayuda al consultorio médico a evaluar su solicitud.",
        "reason-validation": "Por favor elige un motivo.",
        "reason-schmerzen": "dolor",
        "reason-entzuendung": "Inflamación",
        "reason-nachsorge": "Después de la cirugía/procedimiento",
        "reason-allergie": "Alergia/reacción",
        "reason-chronisch": "Condición crónica",
        "reason-anderes": "algo mas",
        "medications-title": "¿Qué medicamentos?",
        "request-hint": "Describa lo que necesita o nombre la receta anterior que desea renovar.",
        "request-placeholder": "por ej. Ibuprofeno 600 mg, igual que la última vez.",
        "request-validation": "Por favor describa qué medicamento necesita.",
        "history-title": "Prescripciones anteriores",
        "history-hint": "Agregue una entrada para completar previamente su solicitud.",
        "history-loading": "Cargando recetas anteriores...",
        "history-error": "No se pudieron cargar recetas anteriores.",
        "history-add": "Añadir",
        "history-added": "Añadido",
        "history-date": "Último: {{date}}",
        "history-request-line": "Renovar: {{medicationName}}",
        "urgency-title": "¿Qué tan urgente es?",
        "urgency-hint": "Ayuda al consultorio médico a priorizar.",
        "urgency-soon": "Urgente",
        "urgency-soon-meta": "Tan pronto como sea posible",
        "urgency-tomorrow": "pronto",
        "urgency-tomorrow-meta": "En los próximos días",
        "urgency-week": "esta semana",
        "urgency-week-meta": "Sin presión de tiempo",
        "lead": "La consulta revisa su solicitud. Tras la aprobación encontrará su receta electrónica en la app de recetas electrónicas o en su tarjeta sanitaria.",
        "history-hint-v2": "Toque una receta anterior para añadirla.",
        "history-retry": "Cargar de nuevo"
      },
      "request-review": {
        "title": "Revisar orden",
        "subtitle": "Revise su solicitud de receta.",
        "request-label": "Medicación solicitada",
        "selected-medications": "Medicamentos seleccionados",
        "free-text-medications": "Medicamentos adicionales",
        "freetext-label": "Otro",
        "quarterly-warning": "Su tarjeta de seguro no se ha leído este trimestre. El consultorio médico puede ponerse en contacto con usted.",
        "egk-warning": "Su tarjeta de seguro no se ha leído este trimestre. El consultorio médico puede ponerse en contacto con usted.",
        "submit": "Enviar",
        "submitting": "Enviando...",
        "submit-error": "No se pudo enviar la solicitud. Por favor inténtalo de nuevo.",
        "back": "Atrás",
        "reason-label": "Razón",
        "urgency-label": "Urgencia",
        "completion-email-choice": "Quiero recibir un correo cuando la consulta haya procesado mi solicitud.",
        "completion-email-label": "Correo electrónico",
        "completion-email-placeholder": "nombre@ejemplo.es",
        "completion-email-hint": "Solo para este mensaje único. La dirección no se guarda como dato maestro.",
        "completion-email-invalid": "Introduzca una dirección de correo válida.",
        "egk-proof-required": "Las solicitudes de receta solo están disponibles después de leer correctamente la tarjeta del seguro. Póngase en contacto con el personal.",
        "title-v2": "Revisar solicitud",
        "completion-email-hint-v2": "La dirección solo se usa para este mensaje."
      },
      "confirmation": {
        "title": "Solicitud enviada",
        "subtitle": "Su solicitud de receta se ha enviado correctamente.",
        "success-title": "Solicitud enviada",
        "success-subtitle": "Su solicitud de receta se ha enviado correctamente.",
        "estimated-time": "Su receta estará lista en aproximadamente {{time}}.",
        "info": "Puede recoger su receta en la farmacia con su tarjeta de seguro o la aplicación eRezept.",
        "auto-redirect": "Redirección automática en {{seconds}} segundos",
        "back-to-start": "Volver al inicio",
        "handling-label": "Handled by the practice",
        "next-steps": "La consulta revisa su solicitud. Tras la aprobación podrá canjear su receta electrónica en la farmacia con su tarjeta sanitaria o la app de recetas electrónicas."
      },
      "phase": {
        "identify": "Identificarse",
        "request": "Solicitud",
        "review": "Revisar"
      }
    },
    "check-in": {
      "flow-label": "Registro",
      "has-appointment": {
        "eyebrow": "Cita",
        "title": "¿Tienes una cita?",
        "subtitle": "Por favor, selecciona una opción",
        "yes-label": "si",
        "yes": "Sí, tengo una cita",
        "yes-description": "Quiero registrarme para mi cita.",
        "yes-hint": "camino más rápido",
        "unsure-label": "tal vez",
        "unsure": "No estoy seguro",
        "unsure-description": "Lo comprobaremos por ti.",
        "unsure-hint": "Te buscaremos",
        "no-label": "No",
        "no": "No, sin cita",
        "no-description": "No tengo una cita.",
        "no-hint": "Sin cita previa"
      },
      "card-check": {
        "eyebrow": "tarjeta de seguro",
        "title": "Leer tarjeta de seguro",
        "subtitle": "Por favor, inserta tu tarjeta de seguro en el lector",
        "insert-title": "Introduzca su tarjeta sanitaria en el lector.",
        "insert-detail": "Leemos tus datos automáticamente, no necesitas hacer nada más.",
        "other-ways": "Otras formas",
        "no-card-hint": "Si no tienes tu tarjeta contigo en este momento.",
        "pkv-hint": "Utilice el QR code con su aplicación de seguros.",
        "loading": "Cargando configuración...",
        "no-terminal": "No hay lector de tarjetas configurado. Por favor, contacta al personal.",
        "checking": "Buscando tarjetas...",
        "insert-prompt": "Por favor, inserta la tarjeta...",
        "card-detected": "¡Tarjeta detectada! Lista para leer.",
        "read-card": "Leer tarjeta",
        "simulate-insert": "Simular tarjeta",
        "reading": "Leyendo tarjeta...",
        "error": "No se pudo leer la tarjeta. Por favor, inténtalo de nuevo.",
        "read-error": "Error al leer los datos de la tarjeta. Por favor, inténtalo de nuevo.",
        "settings-error": "No se pudo cargar la configuración. Por favor, inténtalo de nuevo.",
        "no-card-prompt": "¿No tienes tarjeta?",
        "no-card-action": "Búsqueda manual",
        "connection-warning": "Problemas de conexión con el lector de tarjetas. Por favor espera...",
        "pkv-prompt": "¿Seguro privado? Online Check-in",
        "pkv-instruction": "Escanea este QR code con tu aplicación de seguro médico privado para transmitir tus datos digitalmente.",
        "pkv-continue": "Continuar con el registro manual",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Inténtelo de nuevo o regístrese sin tarjeta. Recepción le ayudará con gusto.",
        "title-pkv": "Registro con la aplicación",
        "title-reading": "Leyendo su tarjeta …",
        "title-unreadable": "No se pudo leer la tarjeta",
        "title-no-terminal": "Registro sin tarjeta",
        "no-terminal-body": "El lector de tarjetas no está disponible en este momento. Regístrese sin tarjeta o diríjase a recepción.",
        "reading-detail": "Deje la tarjeta en el lector. Solo tarda un momento.",
        "other-ways-title": "Otras opciones",
        "no-card-title": "Registrarse sin tarjeta",
        "pkv-prompt-title": "¿Tiene seguro privado?",
        "pkv-prompt-hint": "Registro con la aplicación de su seguro médico privado",
        "pkv-close": "Usar mi tarjeta",
        "pkv-instruction-app": "Abra la aplicación de su seguro médico privado y escanee este código. Sus datos nos llegan directamente."
      },
      "patient-selection": {
        "title": "Seleccionar paciente",
        "subtitle": "Se encontraron varios pacientes. Por favor, selecciónate a ti mismo.",
        "firstname-label": "tu nombre",
        "firstname-placeholder": "Introduzca el nombre...",
        "confirm-button": "Confirmar",
        "no-match": "No se encontró ningún paciente compatible. Dirígete a la recepción para obtener ayuda.",
        "still-ambiguous": "Quedan varios partidos. Dirígete a la recepción para obtener ayuda.",
        "select-error": "No se pudo identificar al paciente. Por favor inténtalo de nuevo.",
        "staff-assist": "Ir a recepción",
        "title-v2": "Una breve pregunta",
        "subtitle-v2": "Por su seguridad, introduzca su nombre.",
        "no-match-v2": "No le hemos encontrado con este nombre. Compruebe la ortografía o diríjase a recepción.",
        "still-ambiguous-v2": "Todavía no hemos podido identificarle con claridad. Diríjase a recepción.",
        "select-error-v2": "Lamentablemente no ha funcionado. Inténtelo de nuevo."
      },
      "card-checkin": {
        "title": "Confirmar Check-in",
        "subtitle": "Tus datos fueron leídos con éxito.",
        "confirm": "Confirmar check-in"
      },
      "register-from-card": {
        "title": "Nuevo registro",
        "subtitle": "Aún no estás en nuestro sistema. ¿Te gustaría registrarte?",
        "card-data": "Datos de la tarjeta",
        "create": "Registrarse",
        "create-error": "El registro falló. Inténtelo de nuevo o solicite ayuda al personal.",
        "staff-assist": "Llamar al personal",
        "no-card-data-title": "Sin datos de tarjeta",
        "no-card-data": "No se pueden leer los datos de su tarjeta.",
        "insurance-verified": "Seguro verificado: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Sus datos de la tarjeta",
        "subtitle-v2": "Compruebe sus datos. Si algo no es correcto, toque «Cambiar».",
        "create-v2": "Confirmar datos",
        "create-error-v2": "El registro no ha funcionado. Inténtelo de nuevo o diríjase a recepción.",
        "insurer-missing-v2": "Su tarjeta no indica su seguro médico. Diríjase a recepción.",
        "edit": "Cambiar",
        "name": "Nombre",
        "insurer": "Seguro médico"
      },
      "patient-lookup": {
        "title": "Buscar paciente",
        "subtitle": "Por favor, introduce tu nombre o número de seguro.",
        "lastname": "apellido",
        "lastname-placeholder": "tu apellido",
        "dob": "fecha de nacimiento",
        "firstname": "nombre",
        "firstname-placeholder": "tu nombre",
        "search": "Buscar",
        "searching": "Buscando...",
        "search-placeholder": "Nombre o número de seguro...",
        "results-placeholder": "Los resultados de la búsqueda aparecerán aquí",
        "found": "¡Paciente encontrado!",
        "confirm-identity": "Confirme que usted es el paciente que se muestra.",
        "confirm-button": "ese soy yo",
        "ambiguous-firstname": "Se encontraron múltiples pacientes. Por favor ingrese su nombre.",
        "ambiguous-additional": "Se encontraron múltiples pacientes. Por favor contacte al personal.",
        "disambiguation-hint": "Esto nos ayuda a identificarlo claramente.",
        "not-found": "No se encontró ningún paciente con estos detalles.",
        "error": "Error de búsqueda: {{message}}",
        "staff-assist": "llamar al personal",
        "not-found-prompt": "¿No encontrado?",
        "register-new": "Registrar nuevo",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Registro sin tarjeta",
        "subtitle-firstname": "Introduzca también su nombre.",
        "ambiguous-firstname-v2": "Hay varias personas con este apellido. Introduzca también su nombre.",
        "search-again": "Buscar de nuevo",
        "found-v2": "Le hemos encontrado",
        "found-confirm": "Confirme con «Soy yo».",
        "not-found-title": "No le hemos encontrado",
        "not-found-check": "Compruebe la ortografía y la fecha de nacimiento. Recepción le ayudará con gusto.",
        "not-found-reception": "Compruebe la ortografía y la fecha de nacimiento o diríjase a recepción.",
        "ambiguous-additional-v2": "No hemos podido identificarle con claridad. Diríjase a recepción.",
        "error-v2": "La búsqueda no ha funcionado en este momento. Inténtelo de nuevo."
      },
      "checking-in": {
        "title": "Un momento: te estamos registrando.",
        "subtitle": "Lo agregaremos a la cola de tratamiento y notificaremos al equipo.",
        "step-insurance": "Seguro comprobado",
        "step-appointment": "Cita confirmada",
        "step-waitlist": "Agregar a la lista de espera",
        "error": "El check-in falló. Por favor inténtalo de nuevo.",
        "continue": "Continuar de todos modos",
        "title-v2": "Un momento, por favor",
        "loading": "Le estamos registrando …",
        "subtitle-v2": "Le añadimos a la lista de espera e informamos al equipo.",
        "error-title": "Lamentablemente no ha funcionado",
        "error-v2": "No se pudo completar su registro.",
        "error-body": "Inténtelo de nuevo. Si sigue sin funcionar, recepción le ayudará."
      },
      "appointment-selection": {
        "title": "Seleccionar cita",
        "subtitle": "Tienes varias citas hoy. Por favor elige uno.",
        "checking-in": "Registrándose...",
        "time": "{{time}}",
        "error-v2": "El registro para esta cita no ha funcionado. Inténtelo de nuevo o diríjase a recepción."
      },
      "no-appointment": {
        "title": "No se encontró ninguna cita",
        "subtitle": "No pudimos encontrar una cita para usted hoy. Por favor reserve una cita regular.",
        "book-appointment": "Reservar cita",
        "book-appointment-description": "Reserve una nueva cita a través del programador habitual.",
        "staff-assist": "llamar al personal",
        "staff-assist-description": "Necesito ayuda.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Hoy no hemos encontrado ninguna cita para usted.",
        "book-v2": "Pedir una cita nueva",
        "book-v2-description": "Elija ahora una cita libre.",
        "have-appointment": "Tengo una cita",
        "have-appointment-description": "Recepción le ayudará con gusto.",
        "unavailable-title": "Pida cita en recepción, por favor",
        "subtitle-unavailable": "Hoy no hemos encontrado ninguna cita para usted. Diríjase a recepción."
      },
      "staff-assist": {
        "title": "Personal notificado",
        "subtitle": "Un miembro del personal le ayudará en breve.",
        "message": "Por favor espera aquí. Un miembro del personal estará con usted en breve.",
        "start-over": "volver al inicio",
        "auto-redirect": "Volviendo al inicio en {{seconds}} segundos..."
      },
      "eeb-prompt": {
        "title": "Verificar seguro",
        "title-failed": "Verificación fallida",
        "subtitle": "¿Cómo te gustaría verificar tu seguro?",
        "subtitle-failed": "Escanea el código QR con tu aplicación de seguro para solicitar la verificación.",
        "verify-card": "Verificar electrónicamente",
        "verify-card-description": "Enviar una solicitud a tu proveedor de seguros.",
        "select-insurer": "Seleccionar aseguradora",
        "select-insurer-description": "Selección manual de tu aseguradora.",
        "skip": "Omitir",
        "eyebrow-chip": "Alternativa",
        "eyebrow": "Check-in · comprobante de seguro (eEB)",
        "recommended": "Recomendado",
        "qr-title": "Escanee con su aplicación de seguro",
        "qr-description": "Abra la aplicación de su seguro médico y escanee el código: el eEB se nos envía directamente.",
        "qr-address-label": "Enviar a",
        "title-app": "Justificante por aplicación",
        "subtitle-app": "Su seguro médico también puede enviarnos el justificante directamente. Cuando haya terminado, toque «Siguiente»."
      },
      "quarterly-check": {
        "title": "Verificación de seguro",
        "checking": "Estamos comprobando tu verificación de seguro actual...",
        "error": "No se pudo realizar la comprobación.",
        "title-v2": "Su seguro",
        "checking-v2": "Estamos comprobando su seguro – un momento, por favor.",
        "error-body": "Su registro está completado. Recepción aclarará su seguro con usted."
      },
      "insurer-prefilled": {
        "title": "Tu seguro de salud",
        "subtitle": "Por favor, confirma tu seguro para este trimestre.",
        "your-insurance": "Tu seguro",
        "last-read": "Última verificación el {{date}}",
        "quarterly-notice": "Para fines de facturación, necesitamos una prueba de seguro actual para este trimestre.",
        "confirm-button": "Sí, este es mi seguro",
        "change-button": "Tengo un seguro diferente",
        "contact-title": "Solicitar prueba electrónica de cobertura",
        "contact-description": "Llame a su seguro y solicite un comprobante electrónico de cobertura para:",
        "contact-patient": "Paciente",
        "contact-kim-address": "Dirección KIM del consultorio médico",
        "contact-phone": "Teléfono",
        "question": "¿Es este su seguro médico?",
        "quarterly-notice-v2": "Una vez por trimestre necesitamos un justificante de su seguro médico."
      },
      "insurer-search": {
        "title": "Seleccionar seguro de salud",
        "subtitle": "Por favor, busca y selecciona tu seguro de salud obligatorio.",
        "placeholder": "Buscar seguro...",
        "hint": "Introduce al menos 2 caracteres para buscar.",
        "no-results": "No se encontró ningún seguro.",
        "no-results-hint": "Comprueba la ortografía o intenta una búsqueda diferente.",
        "label": "Nombre de su seguro médico",
        "search-error-v2": "La búsqueda no ha funcionado en este momento. Inténtelo de nuevo.",
        "app-alternative": "¿Prefiere usar la aplicación de su seguro médico?"
      },
      "insurer-contact": {
        "title": "Solicitar prueba de seguro",
        "subtitle": "Por favor elija una de las siguientes opciones.",
        "or": "o",
        "option-eeb-title": "Solicitar electrónicamente",
        "option-eeb-description": "Si concurre el supuesto legal de excepción, tras su consentimiento puede entregar la solicitud al equipo de la consulta.",
        "option-qr-title": "Escanear con la aplicación",
        "option-qr-description": "Escanee el QR code con su aplicación de seguro.",
        "option-call-title": "Llámate a ti mismo",
        "option-call-description": "Llame a su seguro y solicite un eEB para este consultorio médico:",
        "phone": "Teléfono",
        "phone-not-available": "Número de teléfono en su tarjeta de seguro",
        "patient-name": "Paciente",
        "practice-kim": "Dirección KIM del consultorio médico",
        "help-notice": "Si tiene algún problema, visite la recepción.",
        "submit-eeb-button": "Solicitar ahora",
        "contacted-button": "he llamado",
        "contacted-button-countdown": "Hora de tu llamada ({{seconds}}s)",
        "go-to-counter-button": "Ir a recepción",
        "qr-continue-button": "he escaneado",
        "qr-continue-button-countdown": "Hora de escanear ({{seconds}}s)",
        "title-v2": "Justificante de su seguro médico",
        "subtitle-v2": "Lo más fácil es con la aplicación de su seguro médico.",
        "subtitle-no-app": "Elija cómo debe enviarnos el justificante su seguro médico.",
        "option-eeb-description-v2": "Nosotros lo solicitamos a su seguro médico. Para ello necesitamos su consentimiento.",
        "call-instruction": "Llame a su seguro médico y pida que envíen el justificante a nuestra consulta.",
        "call-instruction-practice": "Llame a su seguro médico y pida que envíen el justificante a la consulta {{practice}}.",
        "done-button": "Hecho – siguiente",
        "done-button-countdown": "Hecho – siguiente (faltan {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Consentimiento",
        "subtitle": "Necesitamos tu consentimiento para la verificación electrónica del seguro.",
        "insurance": "Tu seguro",
        "consent-title": "Consentimiento para la verificación electrónica del seguro (eEB)",
        "consent-text": "Entiendo que mi seguro médico transmitirá mis datos de seguro (por ejemplo, nombre, fecha de nacimiento, número de seguro) a través del servicio de comunicación seguro KIM al consultorio médico {{practiceName}} como prueba de seguro. Doy mi consentimiento para esta transmisión. Soy consciente de que puedo revocar este consentimiento en cualquier momento sin afectar mi tratamiento.",
        "withdrawal-notice": "Puedes revocar este consentimiento en cualquier momento.",
        "agree-button": "Estoy de acuerdo",
        "decline-button": "Cancelar",
        "treatment-notice": "Tu tratamiento no se ve afectado por este consentimiento.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Justificante de su seguro médico",
        "summary": "Su seguro médico nos envía el justificante directamente. Para ello necesitamos su consentimiento.",
        "confirm-first": "Confirme primero la declaración."
      },
      "qr-code": {
        "title": "Escanear con la aplicación del seguro",
        "instruction-1": "Abre la aplicación de tu seguro y escanea este código QR.",
        "instruction-2": "El consultorio médico recibirá automáticamente su verificación de seguro.",
        "practice": "Consultorio médico: {{name}}",
        "alternative-hint": "Alternativa: Usa la aplicación de tu seguro",
        "instruction-app": "Abra la aplicación de su seguro médico y escanee este código. El justificante nos llega directamente.",
        "staff-line": "Para el equipo de la consulta: {{address}}",
        "staff-line-practice": "Para el equipo de la consulta: {{name}} · {{address}}",
        "alternative-app": "También puede solicitar el justificante con la aplicación de su seguro médico: abra la aplicación y escanee este código."
      },
      "register-basics": {
        "title": "Información personal",
        "subtitle": "Por favor, introduce tus datos.",
        "family-name": "Apellido",
        "given-name": "Nombre",
        "dob": "Fecha de nacimiento",
        "gender": "Género",
        "insurance-type": "Tipo de seguro",
        "insurer-name": "Nombre de tu seguro",
        "insurer-name-placeholder": "por ej. Debeka, DKV, Allianz...",
        "gender-required": "Elija una opción."
      },
      "register-insurer": {
        "title": "Seguro de salud",
        "subtitle": "Por favor, selecciona tu seguro de salud.",
        "search-placeholder": "Buscar seguro..."
      },
      "register-details": {
        "title": "Resumen",
        "subtitle": "Por favor, revisa tu información.",
        "create": "Completar registro",
        "missing-data": "Por favor complete todos los campos requeridos.",
        "create-error": "El registro falló. Por favor inténtalo de nuevo.",
        "policy-number": "Número de póliza (opcional)",
        "policy-number-placeholder": "Su número de póliza",
        "create-v2": "Finalizar registro",
        "policy-number-hint": "Encontrará el número en la tarjeta de su seguro."
      },
      "diff-review": {
        "eyebrow-chip": "Revisión",
        "eyebrow": "Check-in · datos de la tarjeta",
        "title": "Comparación de datos",
        "subtitle": "Se encontraron diferencias entre los datos de tu tarjeta y nuestros registros.",
        "col-current": "Registro actual",
        "col-new": "Nuevo de tarjeta",
        "new-badge": "nuevo",
        "field-fallback": "campo",
        "note": "Los datos actualizados nos ayudan a facturar correctamente y comunicarnos con usted en caso de emergencia.",
        "comparison-placeholder": "La comparación se mostrará aquí",
        "confirm": "Confirmar cambios",
        "apply-error": "Los datos no se pudieron aplicar. Por favor inténtalo de nuevo.",
        "retry": "Inténtalo de nuevo",
        "skip": "Continuar de todos modos",
        "no-changes": "No se encontraron cambios",
        "title-v2": "Sus datos han cambiado",
        "subtitle-v2": "Su tarjeta tiene datos más recientes. ¿Los actualizamos?",
        "confirm-v2": "Actualizar y registrarse",
        "keep": "Registrarse sin cambios",
        "col-current-v2": "Antes",
        "col-new-v2": "Nuevo de la tarjeta",
        "value-yes": "Sí",
        "value-no": "No"
      },
      "insurance-selection": {
        "title": "Tipo de seguro",
        "subtitle": "Por favor, selecciona tu tipo de seguro.",
        "gkv": "Asegurado legalmente",
        "gkv-description": "Miembro de un seguro de salud obligatorio.",
        "pkv": "Privado o autopago",
        "pkv-description": "Asegurado privado o autopago.",
        "pkv-description-v2": "Seguro médico privado, o paga usted mismo."
      },
      "eeb-request": {
        "title": "Solicitud registrada",
        "subtitle": "Puede finalizar su registro. La respuesta de {{insurer}} llegará más tarde a la consulta.",
        "verifying": "Su solicitud se ha aceptado para su tramitación inmediata.",
        "success": "Su solicitud se ha entregado de forma segura al equipo de la consulta.",
        "error": "La confirmación de la solicitud no está disponible.",
        "try-alternative": "Método alternativo",
        "kim-load-error": "No se pudo cargar la dirección KIM del consultorio médico.",
        "kim-label": "Consultorio médico · KIM",
        "non-blocking-note": "Esto todavía no confirma la recepción por parte de su seguro médico ni su situación de aseguramiento.",
        "auto-continue": "Continúa automáticamente en {{seconds}} segundos.",
        "unavailable-title": "Lamentablemente no ha funcionado",
        "unavailable-v2": "No se pudo registrar su solicitud al seguro médico.",
        "unavailable-body": "Puede pedir el justificante con la aplicación de su seguro médico o resolverlo en recepción.",
        "use-app": "Con la aplicación",
        "at-reception": "Resolver en recepción"
      },
      "self-pay": {
        "title": "Autopago",
        "subtitle": "Serás tratado como paciente de autopago.",
        "info": "Ten en cuenta que serás responsable de los costos del tratamiento.",
        "confirm": "Entendido",
        "title-v2": "Usted paga",
        "subtitle-v2": "Usted paga el tratamiento.",
        "insured-after-all": "Sí tengo seguro"
      },
      "done": {
        "title": "¡Listo!",
        "subtitle": "Tu check-in está completo.",
        "finish": "Finalizar",
        "done-label": "hecho",
        "error-label": "Aviso",
        "eyebrow": "Check-in · completo",
        "queue-label": "sala de espera",
        "queue-title": "Por favor toma asiento",
        "queue-meta": "Le llamaremos personalmente.",
        "success-title": "¡Check-in exitoso!",
        "success-subtitle": "Por favor, toma asiento en la sala de espera. Serás llamado.",
        "auto-redirect": "Serás redirigido a la página de inicio en breve...",
        "auto-redirect-countdown": "Volviendo al inicio en {{seconds}} segundos...",
        "card-expired-title": "Tarjeta caducada",
        "card-expired-subtitle": "Tu tarjeta de seguro ha caducado.",
        "card-expired-info": "Por favor, contacta al personal para obtener ayuda.",
        "back-to-start": "Volver al inicio",
        "anamnesis-title": "Formulario de historial médico completo",
        "anamnesis-description": "Escanee el QR code para completar su formulario de historial médico cómodamente en su teléfono inteligente.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Está registrado",
        "card-expired-info-v2": "Diríjase a recepción, por favor."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Revisar sus datos",
          "balance-prefix": "Al guardar:",
          "balance-direct-v2": "Guardado al momento: {{count}}",
          "balance-reception-v2": "Lo revisa recepción: {{count}}",
          "chip-reception-v2": "Los cambios los revisa nuestra recepción",
          "chip-changed": "Cambiado: {{count}}",
          "remove": "Quitar",
          "example-email": "p. ej. nombre@ejemplo.es",
          "example-phone": "p. ej. 612 345 678",
          "intro-v2": "Su registro está completado. ¿Siguen siendo correctos estos datos? Revisarlos es opcional.",
          "auto-hide": "Los valores mostrados se vuelven a ocultar al poco tiempo."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Hemos pasado este dato a recepción.",
          "banner-done-v2": "¡Gracias! Hemos recibido sus datos.",
          "footer-v2": "Todos los demás datos se quedan como están."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Por motivos de privacidad hemos cerrado la pantalla. Su registro sigue completado. Puede comunicar cambios en recepción en cualquier momento."
        }
      },
      "progress": {
        "identify": "Registrarse",
        "insurance": "Seguro",
        "done": "Listo"
      },
      "dob-format-hint": "Por ejemplo 01.10.1980",
      "dob-required": "Introduzca su fecha de nacimiento.",
      "insurance-label": {
        "GKV": "Seguro público",
        "PKV": "Seguro privado",
        "SELFPAY": "Pago propio"
      }
    },
    "emergency": {
      "title": "¡Emergencia aguda!",
      "label": "Emergencia",
      "subtitle": "Esta alerta solo se oye localmente y no ha pedido ayuda. En emergencias agudas o potencialmente mortales, llame al 112.",
      "call-emergency": "Llame a los servicios de emergencia (112)",
      "stop-sound": "detener el sonido",
      "play-sound": "Reproducir sonido",
      "back-to-start": "volver al inicio",
      "headline": "Hable de inmediato con el personal de recepción. Si hay peligro de muerte, llame al 112."
    },
    "help-reception": "ayuda en recepción",
    "help-reception-toast": "Por favor contacte con recepción. Estamos felices de poder ayudar.",
    "language-entry": {
      "title": "Elija su idioma"
    },
    "loading": "Cargando…",
    "step-progress-label": "Progreso",
    "step-progress-phase": "Sección {{current}} de {{total}}: {{phase}}",
    "step-progress-substep": "Parte {{current}} de {{total}}",
    "step-progress-complete": "Completado",
    "identification": {
      "title": "¿Quién es usted?",
      "lead": "Lo más rápido es con su tarjeta sanitaria. También puede buscar con su nombre.",
      "lead-card-only": "Introduzca su tarjeta sanitaria en el lector de tarjetas.",
      "mode-label": "¿Cómo desea identificarse?",
      "mode-card": "Con tarjeta",
      "mode-search": "Buscar por nombre",
      "mode-create": "Nuevo en la consulta",
      "card": {
        "loading": "Preparando el lector de tarjetas …",
        "checking": "Comprobando el lector de tarjetas …",
        "insert-title": "Introduzca su tarjeta sanitaria en el lector de tarjetas.",
        "insert-detail": "Leemos sus datos automáticamente.",
        "detected": "Tarjeta detectada",
        "read": "Leer tarjeta",
        "reading": "Leyendo la tarjeta …",
        "reading-hint": "Deje la tarjeta en el lector.",
        "no-terminal-title": "Lector de tarjetas no disponible",
        "help-with-search": "Busque con su nombre o pregunte en recepción.",
        "help-reception": "Pregunte en recepción, le ayudaremos con gusto.",
        "unreadable-title": "Tarjeta detectada, pero no legible",
        "error-title": "No se pudo leer la tarjeta",
        "not-unique": "No pudimos identificarle con claridad con esta tarjeta. Busque con su nombre o pregunte en recepción.",
        "no-match": "No encontramos datos para esta tarjeta. Busque con su nombre o pregunte en recepción.",
        "without-card": "Continuar sin tarjeta"
      },
      "lookup": {
        "lead": "Introduzca su apellido y su fecha de nacimiento.",
        "first-name": "Nombre",
        "last-name": "Apellido",
        "dob": "Fecha de nacimiento",
        "dob-hint": "Formato: DD.MM.AAAA",
        "search": "Buscar",
        "confirm": "Sí, soy yo",
        "found-title": "Le hemos encontrado",
        "found-body": "Confirme que se trata de usted.",
        "first-name-needed-title": "Añada su nombre",
        "first-name-needed-body": "Para encontrarle con claridad. Después toque «Buscar».",
        "ambiguous-title": "No pudimos encontrarle con claridad",
        "ambiguous-body": "Pregunte en recepción, le ayudaremos con gusto.",
        "not-found-title": "No se encontraron datos coincidentes",
        "not-found-body": "Compruebe sus datos.",
        "error-title": "La búsqueda no es posible en este momento",
        "error-body": "Inténtelo de nuevo o pregunte en recepción."
      },
      "create": {
        "insurance-question": "¿Cómo está asegurado?",
        "insurance-required": "Elija cómo está asegurado.",
        "error-title": "No se pudieron guardar sus datos",
        "error-body": "Inténtelo de nuevo o pregunte en recepción."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Desbloquear primero",
      "subtitle": "FrontDesk+ debe estar activado en el software de su consulta.",
      "step1": "Realice su pedido en SolStore (o su socio Doc-Cirrus realiza pedidos por usted).",
      "step2": "Después de la activación, actívela en inSuite en “inSuite Sols” (derechos de administrador).",
      "step3": "Abra la administración de Bridge → “Agregar dispositivo”.",
      "cta": "Todo listo - sigue adelante"
    },
    "welcome": {
      "title": "Añade este dispositivo a la práctica.",
      "scan": "Toma una foto del código.",
      "prepare-link": "¿Sin código en inSuite?",
      "language": "Idioma"
    },
    "scan": {
      "requesting": "Se solicita acceso a la cámara...",
      "scanning": "Apunta la cámara al código.",
      "paste": "Pegar en su lugar",
      "manual-title": "Conectar manualmente",
      "manual-description": "Si el código QR no está disponible, tome los datos de conexión de la administración de Bridge.",
      "address-label": "Dirección de Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Insertar SOLTOKEN",
      "manual-submit": "Tomar el control de la conexión",
      "error-title": "Código no reconocido",
      "camera-denied-title": "Acceso a la cámara denegado",
      "camera-denied-hint": "Permita el acceso a la cámara en la configuración y vuelva a intentarlo.",
      "retry": "Intentar otra vez"
    },
    "preflight": {
      "title": "se establecerá",
      "all-green": "Todas las pruebas pasaron",
      "practice": "Práctica",
      "device-name": "Nombre del dispositivo",
      "device-name-placeholder": "p.ej. B. Recepción 1",
      "card-reader": "Lector de tarjetas",
      "pin": "Nuevo número secreto",
      "pin-placeholder": "PIN de cuatro dígitos",
      "finish": "Finalizar",
      "recheck": "comprobar de nuevo",
      "diagnosis": "Identificación de diagnóstico",
      "checklist-error": "El Bridge rechazó la conexión o no está disponible. Compruebe el SOLTOKEN y la dirección del Bridge.",
      "checklist-retry": "Comprobar de nuevo",
      "edit-token": "Cambiar SOLTOKEN",
      "rescan": "Escanear el código de nuevo"
    },
    "persisting": "Guardando la configuración …",
    "success": {
      "title": "Dispositivo agregado",
      "detail": "El dispositivo acaba de aparecer en el PC de la consulta.",
      "starting": "El modo paciente está comenzando..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Conexión al software de práctica.",
        "fix": "Bridge Verifique la conexión y la dirección del servidor."
      },
      "missing_insuite_url": {
        "label": "inSuite dirección",
        "fix": "Escanee el código QR nuevamente; falta la dirección."
      },
      "missing_server_token": {
        "label": "token de servidor",
        "fix": "Escanee el código QR nuevamente: falta el token."
      },
      "missing_gateway_session": {
        "label": "Sesión Gateway",
        "fix": "Inicie sesión nuevamente: falta la sesión."
      },
      "missing_gateway_enrollment": {
        "label": "Registro de dispositivo",
        "fix": "Registre el dispositivo en Gateway."
      },
      "gateway_not_ready": {
        "label": "Preparación para Gateway",
        "fix": "Espere a que Gateway complete la configuración."
      },
      "token_verification_failed": {
        "label": "Verificación de tokens",
        "fix": "Verifique el token del servidor o la conexión Bridge."
      },
      "session_expired": {
        "label": "reunión",
        "fix": "La sesión ha caducado: inicie sesión nuevamente."
      },
      "device_revoked": {
        "label": "Estado del dispositivo",
        "fix": "Este dispositivo ha sido bloqueado. Póngase en contacto con la práctica."
      },
      "missing_practice_name": {
        "label": "Nombre de la práctica",
        "fix": "No se pudo cargar el nombre de la práctica médica (inSuite)."
      },
      "missing_device_name": {
        "label": "Nombre del dispositivo",
        "fix": "Por favor ingrese un nombre de dispositivo."
      },
      "telematik_unavailable": {
        "label": "Infraestructura telemática",
        "fix": "Opcional: la verificación de la tarjeta sigue siendo posible tan pronto como el TI esté disponible."
      },
      "selected_card_reader_unavailable": {
        "label": "Lector de tarjetas",
        "fix": "Opcional: seleccione o conecte un lector de tarjetas."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Opcional: inserte la tarjeta de credencial de práctica médica (SMC-B)."
      }
    },
    "token": {
      "title": "Introducir SOLTOKEN",
      "description": "Por motivos de seguridad, el código QR no contiene el SOLTOKEN. Cópielo en inSuite en «Sol-Aktivierung» (FrontDesk+) y péguelo aquí.",
      "submit": "Continuar",
      "rescan": "Escanear el código de nuevo"
    }
  }
}
